import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Loader, Modal } from 'semantic-ui-react';
import { DataCategory } from '../../../shared/api/api';
import { useDataCategories } from '../../../shared/api/apiHooks';
import { CategoriesTable } from './CategoriesTable';

import './CategoriesTable.scss';
import { TableDataCategory } from './types';
import { FiltersControl } from '../Filters/types';

interface Props {
  onClose: () => void;
  onCategoryClick?: (category: TableDataCategory) => void;
  selectedCategory?: DataCategory;
  control: FiltersControl;
}

export const CategoriesModal = ({ onClose, onCategoryClick: parentOnCategoryClick, selectedCategory, control }: Props) => {
  const onCategoryClick = (category: TableDataCategory) => {
    onClose();
    parentOnCategoryClick?.(category);
  };

  const { data, isSuccess, isLoading } = useDataCategories();

  return (
    <Modal className={'categories-modal'} size="large" closeIcon={true} open={true} onClose={onClose}>
      <Modal.Header>
        <FormattedMessage id="dataExplorer.filters.categoriesModalTitle" />
      </Modal.Header>
      <Modal.Content>
        {isLoading && (
          <div className="loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        )}
        {isSuccess && (
          <CategoriesTable control={control} selectedCategory={selectedCategory} categories={data} onCategoryClick={onCategoryClick} />
        )}
      </Modal.Content>
    </Modal>
  );
};
